export default "__VITE_ASSET__BH42wpQA__"